import { Component, Input ,OnInit} from '@angular/core';

@Component({
  selector: 'app-articale',
  templateUrl: './articale.component.html',
  styleUrls: ['./articale.component.css'],
})
export class ArticaleComponent implements OnInit {
  @Input() data!: any;

  ngOnInit() {  
console.log("test")
    console.log(this.data)
  }
}
